export const validateName = name => {
    const regex = /^[a-zA-Z ]{2,30}$/;
    if (regex.test(name)) {
        return true;
    }
    return false;
};

export const validatePhone = phone => {
    // const regex = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/;
    // if (regex.test(phone)) {
    //     return true;
    // }
    // return false;
    var length = phone.replace(/\s/g, "").length;


    if (length >= 10 && length <= 10) {
        return true;
    }
    return false;


};

export const validateEmail = email => {
    if (email.includes('@') && email.includes('.')) {
        return true;
    }
    return false;
};
export const validatePassword = password => {
    return password.length > 6;
};
export const validateSignInData = (email, password) => {
    try {
        if (validateEmail(email) && password) {
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};

export const validateSignUpData = (name, email, password) => {
    try {
        if (
            validateEmail(email) &&
            validateName(name) &&
            validatePassword(password)
        ) {
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};

export const validateReferral = (name, phone, referral,  done) => {
    let validation = true;
    const regex = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/;
    if (regex.test(name)) {
        if (name == '') {
            validation = false;
            done({ 
                // nameError: 'Enter valid name',
                fullNameErr: true
            });
        }
    }

    // if (!validateEmail(email)) {
    //     validation = false;
    //     done({ emailError: 'Enter valid email' });
    // }
    if (!validatePhone(phone)) {
        validation = false;
        done({ 
            // phoneError: 'Enter valid mobile number',
            mobileErr: true
        });
    }

    if (regex.test(referral)) {
        if (referral == '') {
            validation = false;
            done({ 
                // uni_idError: 'Please generate refer code',
                referalErr: true
            });
        }
    }

    // if (otp === '') {
    //     validation = false;
    //     done({ otpError: 'Enter OTP' });
    // }
    /* if (!validatePasswordForSignUp(password, (error) => {
        done({ error });
    })) {
        validation = false;
    } */
    return validation;
};


// WEBPACK FOOTER //
// ./src/utils/helpers/functions/validators.js